
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import AddToCartDialog from "../../../components/dialogs/add-to-cart-dialog.vue";
import AddedItemCustomisationDialog from "../../../components/dialogs/added-item-customisation-dialog.vue";
import itemAddedCard from "../../../components/menu-order/item-added-card.vue";

export default {
  components: { itemAddedCard, AddToCartDialog, AddedItemCustomisationDialog },
  layout: "blankOrder",
  data() {
    return {
      search: "",
      brandId: "",
      selectedItemToAdd: {},
      selectedItemToCustomise: {},
      showAddToCartDialog: false,
      showAddedItemCustomisationDialog: false
    };
  },
  created() {
    this.fetch();
    this.$nuxt.$on("open-add-to-cart-dialog", this.handleOpenAddToCartDialog);
    this.$nuxt.$on(
      "open-added-item-customisation-dialog",
      this.handleOpenAddedItemCustomisationDialog
    );
  },
  beforeMount() {
    this.SET_SELECTED_GROUP_BY_MENU("category");
  },
  mounted() {
    if (this.$route.params && this.$route.query.brandId) {
      this.brandId = this.$route.query.brandId;
    }
  },
  computed: {
    ...mapGetters("menu", ["getGroupedMenu"]),
    ...mapState("order", ["cart"]),
    ...mapState("menu", ["menuLoading", "menuItems"]),
    filteredItems() {
      const searchTerm = this.search?.trim().toLowerCase();
      const allItems = this.getGroupedMenu
        .filter((category) => category.id !== "all-items")
        .flatMap((category) => [
          ...(category.items || []),
          ...(category.subcategories
            ? category.subcategories.flatMap((sub) => sub.items || [])
            : [])
        ]);

      const uniqueItems = Array.from(
        new Map(allItems.map((item) => [item.id, item])).values()
      );

      const filteredByAddons = this.filterItemsWithValidAddons(uniqueItems);

      return filteredByAddons.filter((item) => {
        const name = item?.combo_items?.length ? item.name : item.item_name;
        return (
          item?.restaurant_ids?.includes(+this.brandId) &&
          (!searchTerm || name?.toLowerCase().includes(searchTerm))
        );
      });
    }
  },

  methods: {
    ...mapActions("menu", ["getMenuListForOrder"]),
    ...mapMutations("menu", ["SET_MENU_LOADING", "SET_SELECTED_GROUP_BY_MENU"]),
    async fetch() {
      this.SET_MENU_LOADING(true);
      await Promise.all([
        this.getMenuListForOrder({
          forceFetch: false,
          brandId: this.brandId
        })
      ]);
      this.SET_MENU_LOADING(false);
    },
    handleBack() {
      this.$router.push("/order/menu");
    },
    handleScroll() {
      this.$refs.menuHeaderSearchField.blur();
    },
    handleOpenAddToCartDialog(item) {
      this.showAddToCartDialog = true;
      this.selectedItemToAdd = { ...item };
    },
    handleOpenAddedItemCustomisationDialog(item) {
      this.showAddedItemCustomisationDialog = true;
      this.selectedItemToCustomise = { ...item };
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("open-add-to-cart-dialog");
    this.$nuxt.$off("open-added-item-customisation-dialog");
  }
};
